function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "CF0FE6A0-6634-4E94-A593-929425119FD5");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "3.061617e-15%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7931E",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAB535",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Klientska-zona",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Mobil-Menu-1_0_0",
  transform: "translate(-327.000000, -384.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(24.000000, 156.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(157.000000, 224.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Otazky",
  transform: "translate(146.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8D8D8",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("g", {
  id: "shopping-bag-2",
  transform: "translate(3.000000, 0.000000)",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "shopping-bag"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5,0 C12.5556849,0 15.0416667,2.51215 15.0416667,5.6 L15.0416667,5.6 L15.0416667,6.4 L18.2083333,6.4 C18.6455807,6.4 19,6.7582 19,7.2 L19,7.2 L19,21.6 C19,22.92335 17.9345651,24 16.625,24 L16.625,24 L2.375,24 C1.0654349,24 0,22.92335 0,21.6 L0,21.6 L0,7.2 C0,6.7582 0.354419271,6.4 0.791666667,6.4 L0.791666667,6.4 L3.95833333,6.4 L3.95833333,5.6 C3.95833333,2.51215 6.4443151,0 9.5,0 Z M3.95833333,8 L1.58333333,8 L1.58333333,21.6 C1.58333333,22.0411 1.93849479,22.4 2.375,22.4 L2.375,22.4 L16.625,22.4 C17.0615052,22.4 17.4166667,22.0411 17.4166667,21.6 L17.4166667,21.6 L17.4166667,8 L15.0416667,8 L15.0416667,8.8 C15.0416667,9.2418 14.6872474,9.6 14.25,9.6 C13.8127526,9.6 13.4583333,9.2418 13.4583333,8.8 L13.4583333,8.8 L13.4583333,8 L5.54166667,8 L5.54166667,8.8 C5.54166667,9.2418 5.1872474,9.6 4.75,9.6 C4.3127526,9.6 3.95833333,9.2418 3.95833333,8.8 L3.95833333,8.8 L3.95833333,8 Z M11.6459115,11.90885 C11.9144349,11.56015 12.4117995,11.4973 12.7568672,11.7685 C13.1019844,12.03975 13.1641797,12.5424 12.8957552,12.89115 L12.8957552,12.89115 L7.35408854,20.09115 C7.19798177,20.2939 6.96453906,20.40005 6.7286224,20.40005 C6.0785651,20.40005 5.69713021,19.63785 6.10424479,19.10885 L6.10424479,19.10885 Z M12.2708333,17.2 C13.1452842,17.2 13.8541667,17.9163444 13.8541667,18.8 C13.8541667,19.6836556 13.1452842,20.4 12.2708333,20.4 C11.3963825,20.4 10.6875,19.6836556 10.6875,18.8 C10.6875,17.9163444 11.3963825,17.2 12.2708333,17.2 Z M6.72916667,11.6 C7.60361752,11.6 8.3125,12.3163444 8.3125,13.2 C8.3125,14.0836556 7.60361752,14.8 6.72916667,14.8 C5.85471581,14.8 5.14583333,14.0836556 5.14583333,13.2 C5.14583333,12.3163444 5.85471581,11.6 6.72916667,11.6 Z M9.5,1.6 C7.317375,1.6 5.54166667,3.3944 5.54166667,5.6 L5.54166667,5.6 L5.54166667,6.4 L13.4583333,6.4 L13.4583333,5.6 C13.4583333,3.3944 11.682625,1.6 9.5,1.6 Z",
  id: "Combined-Shape"
}))))))));

var SvgSecondaryMarket = function SvgSecondaryMarket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecondaryMarket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/secondary-market.79f3e284.svg";
export { ForwardRef as ReactComponent };